const swiperHomeMember = new Swiper('.js-swiper-home-member', {
  loop: true,
  slidesPerView: 1.4,
  spaceBetween: 16,
  centeredSlides: true,
  navigation: {
    nextEl: '.js-swiper-button-next',
    prevEl: '.js-swiper-button-prev',
  },
  breakpoints: {
    640: {
      slidesPerView: 2.5,
      spaceBetween: 24,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 32,
      loop: true,
      centeredSlides: false,
    },
  },
});

const swiperMemberLocalNav = new Swiper('.js-swiper-member-local-nav', {
  loop: true,
  slidesPerView: 1.4,
  spaceBetween: 16,
  centeredSlides: true,
  navigation: {
    nextEl: '.js-swiper-button-next',
    prevEl: '.js-swiper-button-prev',
  },
  breakpoints: {
    640: {
      slidesPerView: 2.5,
      spaceBetween: 24,
    },
    1024: {
      slidesPerView: 4,
      spaceBetween: 32,
      loop: true,
      centeredSlides: false,
    },
  },
});
